
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 26.41c-1.179 3.42-4.709 9.476-8.345 9.542-2.412.047-3.187-1.43-5.944-1.43-2.755 0-3.618 1.385-5.898 1.475C5.955 36.145 0 27.257 0 19.505 0 12.383 4.962 8.854 9.297 8.79c2.325-.042 4.521 1.568 5.938 1.568 1.424 0 4.091-1.936 6.895-1.652 1.172.05 4.468.473 6.583 3.566C23.102 15.933 23.976 23.595 30 26.41zM22.167 0c-4.239.171-7.698 4.619-7.215 8.296C18.87 8.601 22.629 4.21 22.167 0z","fill":"#fff"}})])
          )
        }
      }
    